import { API_BASE, authHeaders } from "../api/client";
import { toLocalISO, addDaysISO } from "./dates";

export const ANNUAL_LEAVE_TYPE_CODES = new Set(["3012"]);
export const SICK_LEAVE_TYPE_CODES = new Set(["3013", "3014"]);
export const SICK_LEAVE_DEFAULT_RANGE_DAYS = 3; // today through today+2

export function defaultSickLeaveRangeFromToday() {
  const from = toLocalISO(new Date());
  const to = addDaysISO(from, SICK_LEAVE_DEFAULT_RANGE_DAYS - 1);
  return { from, to };
}

export function leaveCatalogIcon(code) {
  const icons = {
    "3012": "🌿",
    "3013": "🤒",
    "3014": "🤒",
    "3015": "🤰",
    "3016": "🤰",
    "3056": "💒",
    "3058": "🕯️",
    "3477": "👶",
    "3387": "🩸",
  };
  return icons[code] || "📋";
}

export function leaveRequestMeta(type, lang, catalogTypes = []) {
  const catalog = catalogTypes.find((entry) => entry.code === type);
  if (catalog) {
    return {
      icon: leaveCatalogIcon(catalog.code),
      bg: catalog.requires_document ? "#FEE2E2" : "var(--green-light)",
      label: lang === "gr" ? catalog.label_gr : catalog.label_en,
      adminLabel: lang === "gr" ? catalog.label_gr : catalog.label_en,
    };
  }
  const labels = {
    rest_day: {
      icon: "🔄",
      bg: "#FEF9C3",
      label: lang === "gr" ? "Ρεπό" : "Rest Day",
      adminLabel: lang === "gr" ? "Ρεπό" : "Rest Day",
    },
    shift_swap: {
      icon: "↔️",
      bg: "#EDE9FF",
      label: lang === "gr" ? "Αλλαγή βάρδιας" : "Shift Swap",
      adminLabel: lang === "gr" ? "Αλλαγή Βάρδιας" : "Shift Swap",
    },
    shift_preference: {
      icon: "🕐",
      bg: "#E0F2FE",
      label: lang === "gr" ? "Προτίμηση Βάρδιας" : "Shift Preference",
      adminLabel: lang === "gr" ? "Προτίμηση Βάρδιας" : "Shift Preference",
    },
    sick: {
      icon: "🤒",
      bg: "#FEE2E2",
      label: lang === "gr" ? "Ασθένεια" : "Sick Leave",
      adminLabel: lang === "gr" ? "Ασθένεια" : "Sick Leave",
    },
  };
  return labels[type] || {
    icon: leaveCatalogIcon(type),
    bg: "#F3F4F6",
    label: type,
    adminLabel: type,
  };
}

export function defaultCatalogLeaveType(catalogLeaveTypes) {
  const annual = catalogLeaveTypes.find((entry) => entry.code === "3012");
  return annual?.code || catalogLeaveTypes[0]?.code || "3012";
}

export const STORE_DEFAULT_HOURS = {
  "PG Dousmani": {"Mon":"10:00-22:00","Tue":"10:00-22:00","Wed":"10:00-22:00","Thu":"10:00-22:00","Fri":"10:00-22:00","Sat":"10:00-22:00","Sun":"11:00-20:00"},
  "PG-ATH-DOUSMANI": {"Mon":"10:00-22:00","Tue":"10:00-22:00","Wed":"10:00-22:00","Thu":"10:00-22:00","Fri":"10:00-22:00","Sat":"10:00-22:00","Sun":"11:00-20:00"},
  "PG Skoufa":   {"Mon":"10:00-22:00","Tue":"10:00-22:00","Wed":"10:00-22:00","Thu":"10:00-22:00","Fri":"10:00-22:00","Sat":"10:00-22:00","Sun":"11:00-20:00"},
  "PG-ATH-SKOUFA": {"Mon":"10:00-22:00","Tue":"10:00-22:00","Wed":"10:00-22:00","Thu":"10:00-22:00","Fri":"10:00-22:00","Sat":"10:00-22:00","Sun":"11:00-20:00"},
  "PG Omirou":   {"Mon":"10:00-22:00","Tue":"10:00-22:00","Wed":"10:00-22:00","Thu":"10:00-22:00","Fri":"10:00-22:00","Sat":"10:00-21:00","Sun":"10:00-20:30"},
  "PG-ATH-OMIROU": {"Mon":"10:00-22:00","Tue":"10:00-22:00","Wed":"10:00-22:00","Thu":"10:00-22:00","Fri":"10:00-22:00","Sat":"10:00-21:00","Sun":"10:00-20:30"},
  "PG Panormou": {"Mon":"10:00-23:00","Tue":"10:00-23:00","Wed":"10:00-23:00","Thu":"10:00-23:00","Fri":"10:00-23:00","Sat":"10:00-23:00","Sun":"10:00-23:00"},
  "PG-ATH-PANORMOU": {"Mon":"10:00-23:00","Tue":"10:00-23:00","Wed":"10:00-23:00","Thu":"10:00-23:00","Fri":"10:00-23:00","Sat":"10:00-23:00","Sun":"10:00-23:00"},
  "PG Heiden":   {"Mon":"08:00-19:30","Tue":"08:00-19:30","Wed":"08:00-19:30","Thu":"08:00-19:30","Fri":"08:00-19:30","Sat":"CLOSED","Sun":"CLOSED"},
  "PG-ATH-HEIDEN": {"Mon":"08:00-19:30","Tue":"08:00-19:30","Wed":"08:00-19:30","Thu":"08:00-19:30","Fri":"08:00-19:30","Sat":"CLOSED","Sun":"CLOSED"},
  "PG Tsamadou": {"Mon":"10:00-21:00","Tue":"10:00-21:00","Wed":"10:00-21:00","Thu":"10:00-21:00","Fri":"10:00-21:00","Sat":"10:00-21:00","Sun":"10:00-21:00"},
  "PG-ATH-TSAMADOU": {"Mon":"10:00-21:00","Tue":"10:00-21:00","Wed":"10:00-21:00","Thu":"10:00-21:00","Fri":"10:00-21:00","Sat":"10:00-21:00","Sun":"10:00-21:00"},
  "PG Kolokotroni": {"Mon":"10:00-22:00","Tue":"10:00-22:00","Wed":"10:00-22:00","Thu":"10:00-22:00","Fri":"10:00-22:00","Sat":"10:00-22:00","Sun":"10:00-22:00"},
  "PG-ATH-KOLOKOTRONI": {"Mon":"10:00-22:00","Tue":"10:00-22:00","Wed":"10:00-22:00","Thu":"10:00-22:00","Fri":"10:00-22:00","Sat":"10:00-22:00","Sun":"10:00-22:00"},
  "PG Drakou": {"Mon":"10:00-22:00","Tue":"10:00-22:00","Wed":"10:00-22:00","Thu":"10:00-22:00","Fri":"10:00-22:00","Sat":"10:00-22:00","Sun":"11:00-20:00"},
  "PG-ATH-DRAKOU": {"Mon":"10:00-22:00","Tue":"10:00-22:00","Wed":"10:00-22:00","Thu":"10:00-22:00","Fri":"10:00-22:00","Sat":"10:00-22:00","Sun":"11:00-20:00"},
  "PG-PAP-KINGS": {"Mon":"10:00-22:00","Tue":"10:00-22:00","Wed":"10:00-22:00","Thu":"10:00-22:00","Fri":"10:00-22:00","Sat":"10:00-22:00","Sun":"11:00-20:00"},
};

export function leaveCalculationBasisLabel(basis, lang = "en") {
  if (basis === "override") {
    return lang === "gr" ? "Βάση: HR override" : "Basis: HR override";
  }
  return lang === "gr" ? "Βάση: κλιμάκιο" : "Basis: tier";
}

export const LEAVE_OVERRIDE_NOTE_MIN_LENGTH = 10;

export const MAX_LEAVE_DOCUMENT_BYTES = 5 * 1024 * 1024;
export const MAX_LEAVE_DOCUMENT_FILES = 3;
export const ALLOWED_LEAVE_DOCUMENT_TYPES = new Set([
  "application/pdf",
  "image/jpeg",
  "image/png",
]);

export function fetchStaffLeaveBalance(employeeCode, { signal } = {}) {
  const code = String(employeeCode || "").trim();
  if (!code) return Promise.resolve(null);
  return fetch(
    `${API_BASE}/staff/${encodeURIComponent(code)}/leave-balance`,
    { headers: authHeaders(), signal }
  ).then((r) => (r.ok ? r.json() : null));
}